/**
 * I FORNITORI NOTI: i principali studi di giochi del casino' online, con il
 * nome come lo scrivono di solito e il file del logo in /assets/fornitori/.
 *
 * I NOMI VERI arrivano da casino-service, nel campo `fornitore` di ogni
 * gioco: questo elenco non ne inventa nessuno, serve solo a dare un logo a
 * un nome. Il logo si cerca in quest'ordine (logoFornitore):
 *   1. quello CARICATO NEL BACKOFFICE (Moduli › Home › Fornitori), dove il
 *      nome combacia: e' la skin che decide, e vince sempre;
 *   2. il file in /assets/fornitori/<slug>.svg, se il nome e' di un
 *      fornitore noto (lo stesso nome scritto in modi diversi combacia lo
 *      stesso: «Play'n GO», «playngo», «Play n Go»);
 *   3. niente: chi disegna scrive il nome nel riquadro, come prima.
 *
 * I FILE sono i loghi ufficiali, presi dai siti dei fornitori (ottobre 2026),
 * a sfondo trasparente e con le scritte nere rese bianche per il fondo scuro;
 * dove il logo ufficiale non c'e' resta una scritta col nome. Un logo nuovo
 * sostituisce il suo file con lo stesso nome, senza toccare altro. `alias`
 * sono le altre grafie con cui lo stesso studio arriva dai cataloghi.
 */
export const FORNITORI_NOTI = [
  {slug: 'pragmatic-play', nome: 'Pragmatic Play', alias: ['pragmatic', 'pragmaticplaylive', 'pragmaticlive']},
  {slug: 'evolution', nome: 'Evolution', alias: ['evolutiongaming', 'evo', 'evolutionlive']},
  {slug: 'netent', nome: 'NetEnt', alias: ['netentertainment', 'netentlive']},
  {slug: 'playn-go', nome: "Play'n GO", alias: ['playngo', 'playandgo']},
  {slug: 'hacksaw-gaming', nome: 'Hacksaw Gaming', alias: ['hacksaw']},
  {slug: 'nolimit-city', nome: 'Nolimit City', alias: ['nolimit', 'nolimitcity']},
  {slug: 'push-gaming', nome: 'Push Gaming', alias: ['push']},
  {slug: 'red-tiger', nome: 'Red Tiger', alias: ['redtigergaming', 'redtiger']},
  {slug: 'big-time-gaming', nome: 'Big Time Gaming', alias: ['btg', 'bigtime']},
  {slug: 'relax-gaming', nome: 'Relax Gaming', alias: ['relax']},
  {slug: 'playtech', nome: 'Playtech', alias: ['playtechlive']},
  {slug: 'microgaming', nome: 'Microgaming', alias: ['gamesglobal']},
  {slug: 'yggdrasil', nome: 'Yggdrasil', alias: ['yggdrasilgaming', 'ygg']},
  {slug: 'quickspin', nome: 'Quickspin', alias: []},
  {slug: 'thunderkick', nome: 'Thunderkick', alias: []},
  {slug: 'elk-studios', nome: 'ELK Studios', alias: ['elk']},
  {slug: 'blueprint-gaming', nome: 'Blueprint Gaming', alias: ['blueprint']},
  {slug: 'booongo', nome: 'Booongo', alias: ['bng']},
  {slug: 'endorphina', nome: 'Endorphina', alias: []},
  {slug: 'spinomenal', nome: 'Spinomenal', alias: []},
  {slug: 'wazdan', nome: 'Wazdan', alias: []},
  {slug: 'amatic', nome: 'Amatic', alias: ['amaticindustries']},
  {slug: 'egt', nome: 'EGT', alias: ['egtinteractive', 'eurogames']},
  {slug: 'habanero', nome: 'Habanero', alias: ['habanerosystems']},
  {slug: 'isoftbet', nome: 'iSoftBet', alias: []},
  {slug: 'playson', nome: 'Playson', alias: []},
  {slug: 'bgaming', nome: 'BGaming', alias: []},
  {slug: '3-oaks', nome: '3 Oaks Gaming', alias: ['3oaks', 'threeoaks']},
  {slug: 'spribe', nome: 'Spribe', alias: []},
  {slug: 'ezugi', nome: 'Ezugi', alias: []},
  {slug: 'vivo-gaming', nome: 'Vivo Gaming', alias: ['vivo']},
  {slug: 'betsoft', nome: 'Betsoft', alias: ['betsoftgaming']},
  {slug: 'pg-soft', nome: 'PG Soft', alias: ['pgsoft', 'pocketgamessoft']},
  {slug: 'gamomat', nome: 'Gamomat', alias: []},
  {slug: 'kalamba-games', nome: 'Kalamba Games', alias: ['kalamba']},
  {slug: 'print-studios', nome: 'Print Studios', alias: []},
  {slug: 'avatarux', nome: 'AvatarUX', alias: []},
  {slug: 'fantasma-games', nome: 'Fantasma Games', alias: ['fantasma']},
  {slug: '1x2-gaming', nome: '1x2 Gaming', alias: ['1x2', '1x2network', 'irondogstudio']},
  {slug: 'evoplay', nome: 'Evoplay', alias: ['evoplayentertainment']},
  {slug: 'platipus', nome: 'Platipus', alias: ['platipusgaming']},
  {slug: 'onetouch', nome: 'OneTouch', alias: ['1touch']},
  {slug: 'turbo-games', nome: 'Turbo Games', alias: ['turbogames']},
  {slug: 'smartsoft', nome: 'SmartSoft', alias: ['smartsoftgaming']},
  {slug: 'tom-horn', nome: 'Tom Horn', alias: ['tomhorngaming']},
  {slug: 'mancala-gaming', nome: 'Mancala Gaming', alias: ['mancala']},
  {slug: 'caleta', nome: 'Caleta Gaming', alias: ['caletagaming']},
  {slug: 'belatra', nome: 'Belatra Games', alias: ['belatragames', 'belatra']},
  /* Gli studi che il catalogo della piattaforma manda oggi (ottobre 2026) e che sopra non c'erano. */
  {slug: 'ka-gaming', nome: 'KA Gaming', alias: ['kagaming']},
  {slug: 'amusnet', nome: 'Amusnet Interactive', alias: ['amusnet']},
  {slug: 'egt-digital', nome: 'EGT Digital', alias: ['egtdigital']},
  {slug: 'reel-kingdom', nome: 'Reel Kingdom', alias: []},
  {slug: 'greentube', nome: 'Greentube', alias: ['novomatic']},
  {slug: 'joker-gaming', nome: 'Joker Gaming', alias: ['joker']},
  {slug: 'jili', nome: 'JILI', alias: ['jiligames']},
  {slug: 'rubyplay', nome: 'RubyPlay', alias: []},
  {slug: 'amigo-gaming', nome: 'Amigo Gaming', alias: ['amigo']},
  {slug: 'red-rake', nome: 'Red Rake Gaming', alias: ['redrake']},
  {slug: 'dreamtech', nome: 'DreamTech', alias: ['dreamtechgaming']},
  {slug: 'igt', nome: 'IGT', alias: []},
  {slug: 'kajot', nome: 'Kajot', alias: ['kajotgames']},
  {slug: 'booming-games', nome: 'Booming Games', alias: ['booming']},
  {slug: 'fastspin', nome: 'FastSpin', alias: []},
  {slug: 'jdb', nome: 'JDB', alias: ['jdbgaming']},
  {slug: 'nextspin', nome: 'NextSpin', alias: []},
  {slug: 'fazi', nome: 'Fazi', alias: ['fazicompany', 'faziinteractive']},
  {slug: 'pateplay', nome: 'Pateplay', alias: []},
  {slug: 'fachai', nome: 'FaChai', alias: ['fachaigaming']},
  {slug: 'gaminator', nome: 'Gaminator', alias: []},
  {slug: 'toptrend-gaming', nome: 'TopTrend Gaming', alias: ['toptrend']},
  {slug: 'fat-panda', nome: 'Fat Panda', alias: []},
  {slug: 'yellowbat', nome: 'YellowBat', alias: []},
  {slug: 'croco-gaming', nome: 'Croco Gaming', alias: ['croco']},
  {slug: 'backseat-gaming', nome: 'Backseat Gaming', alias: ['backseat']},
  {slug: 'bomba', nome: 'Bomba Games', alias: ['bomba']},
  {slug: 'iconix', nome: 'Iconix', alias: []},
  {slug: 'konami', nome: 'Konami', alias: ['konamigaming']},
  {slug: 'zitro', nome: 'Zitro', alias: ['zitrogaming']},
  {slug: 'apollo-games', nome: 'Apollo Games', alias: ['apollo']},
  {slug: 'mga', nome: 'MGA Games', alias: ['mga']},
  {slug: '1spin4win', nome: '1spin4win', alias: []},
  {slug: 'fish-hunter', nome: 'Fish Hunter', alias: []},
  {slug: 'mascot-gaming', nome: 'Mascot Gaming', alias: ['mascot']},
  {slug: 'wmg', nome: 'WMG', alias: ['worldmatch']},
  {slug: 'atg', nome: 'ATG', alias: []},
  {slug: 'aviatrix', nome: 'Aviatrix', alias: []},
  {slug: 'playace', nome: 'PlayAce', alias: []},
  {slug: 'cq9', nome: 'CQ9 Gaming', alias: ['cqgaming', 'cq9gaming']},
  {slug: 'ssg', nome: 'SSG', alias: []},
];

/** Un nome ridotto a sole lettere e cifre minuscole: cosi' «Play'n GO» e «playngo» sono uguali. */
export function chiaveNome(nome) {
  return String(nome || '').toLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
}

const PER_CHIAVE = new Map();
FORNITORI_NOTI.forEach((f) => {
  [f.nome, f.slug].concat(f.alias).forEach((n) => { if (!PER_CHIAVE.has(chiaveNome(n))) PER_CHIAVE.set(chiaveNome(n), f); });
});

/** Il fornitore noto con quel nome (in una grafia qualunque), o null. */
export function fornitoreNoto(nome) {
  const k = chiaveNome(nome);
  if (!k) return null;
  return PER_CHIAVE.get(k) || null;
}

/** L'indirizzo del logo di serie di un fornitore noto, o ''. */
export function logoDiSerie(nome) {
  const f = fornitoreNoto(nome);
  return f ? '/assets/fornitori/' + f.slug + '.svg' : '';
}

/**
 * Il logo da mostrare per un nome: prima quello caricato nel backoffice
 * (`loghi`: [{nome, immagine}], da loghiFornitori()), poi quello di serie,
 * altrimenti ''. L'indirizzo di un logo caricato va poi da indirizzoImmagine,
 * come sempre; quello di serie e' gia' buono.
 */
export function logoFornitore(nome, loghi) {
  const k = chiaveNome(nome);
  if (!k) return '';
  const caricato = (Array.isArray(loghi) ? loghi : []).find((l) => l && chiaveNome(l.nome) === k && String(l.immagine || '').trim());
  if (caricato) return String(caricato.immagine).trim();
  return logoDiSerie(nome);
}
